import { render, staticRenderFns } from "./AzureCallback.vue?vue&type=template&id=2536d5b2&scoped=true"
import script from "./AzureCallback.vue?vue&type=script&lang=js"
export * from "./AzureCallback.vue?vue&type=script&lang=js"
import style0 from "./AzureCallback.vue?vue&type=style&index=0&id=2536d5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536d5b2",
  null
  
)

export default component.exports